import { FC } from 'react';
import { generalHthHelper } from '@monorepo/helpers';
import { InfoBox } from '@react-google-maps/api';
import { typeHTHFace, typeTerritoryNumber } from '@monorepo/models';

type propsType = {
    onClickHandler?: () => void;
    polygon: typeHTHFace;
    territoryNumber: typeTerritoryNumber | number;
    usingLettersForBlocks: boolean;
};

export const HTHPolygonInfoBox: FC<propsType> = ({ onClickHandler, polygon, territoryNumber, usingLettersForBlocks }) => {

    return (
        <div onClick={onClickHandler}>
            <InfoBox
                options={{
                    boxClass: 'bg-general-red',
                    boxStyle: {
                        border: '6px solid black',
                        borderRadius: '5px',
                        color: '#ffffff',
                        font: '15px Sans-serif',
                        fontWeight: 'bold',
                        height: '42px',
                        padding: '6px',
                        textAlign: 'center',
                        width: '260px'
                    },
                    closeBoxURL: '',
                    disableAutoPan: true,
                    enableEventPropagation: true
                }}
                position={new google.maps.LatLng(
                    (polygon.coordsPoint1.lat + polygon.coordsPoint2.lat + polygon.coordsPoint3.lat) / 3 + 0.00007,
                    (polygon.coordsPoint1.lng + polygon.coordsPoint2.lng + polygon.coordsPoint3.lng) / 3 - 0.0006
                )}
            >
                <div onClick={onClickHandler}>
                    T. {territoryNumber} Manzana {generalHthHelper.MaskTheBlock(polygon.block, usingLettersForBlocks)} - {polygon.street}
                </div>
            </InfoBox>
        </div>
    );
}
